import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Layout from '../Layout/Loadable';
import Form from './components/form';
import { messages } from './messages';
import { selectLogin } from './slice/selectors';
import { loginActions as actions } from './slice';
import './style/index.less';
import { useHistory } from 'react-router-dom';
import { auth } from 'utils/auth';

export function LoginModule() {
  const { submit, error } = useSelector(selectLogin);
  const [invalidError, setInvalidError] = useState<{
    error: string;
    errorDescription: string;
  } | null>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (auth.getToken()) {
      history.push('/dashboard');
    }
  }, []);
  useEffect(() => {
    if (submit) {
      dispatch(actions.setLoginSuccess(false));
      // history.push('/dashboard');
      window.location.href = '/dashboard';
    }
  }, [submit, dispatch, history]);
  useEffect(() => {
    if (error) {
      setInvalidError(error);
      dispatch(actions.setLoginError(null));
    }
  }, [error]);

  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Login Page</title>
        <meta name="description" content="Login Page" />
      </Helmet>
      <Layout type={2}>
        <div className="login-section">
          <h1>{t(...messages.loginHeading())}</h1>
          <Form error={invalidError} />
        </div>
      </Layout>
    </>
  );
}
